import { render } from "./Activate2FAProvider.vue?vue&type=template&id=6b61aebf&scoped=true"
import script from "./Activate2FAProvider.vue?vue&type=script&lang=js"
export * from "./Activate2FAProvider.vue?vue&type=script&lang=js"

import "./Activate2FAProvider.vue?vue&type=style&index=0&id=6b61aebf&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b61aebf"]])

export default __exports__